<h1 class="mt-5">Mantenedor reemplazo docente</h1>
<div *ngIf="alertaExitosa !== ''" class="alert alert-success tipografía_alertas mt-4 mb-4" role="alert">
	<i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>
	{{ alertaExitosa }}
</div>
<!-- CRITERIOS DE BUSQUEDA -->
<div class="row mt-5 align-items-center">
	<div class="hr-amarillo mr-3"></div>
	<h6 class="mb-0">Criterios de búsqueda</h6>

	<div *ngIf="alertaCreacionReemplazoDocenteDp !== ''" class="alert alert-success tipografía_alertas mt-5 mb-1 col-12" role="alert">
		<i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i>
		{{ alertaCreacionReemplazoDocenteDp }}
	</div>
</div>
<form class="form" [formGroup]="parametrosFormDp">
	<div class="row mt-5 align-items-end">
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Año</label><label
			class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
			<select id="select_anyo" class="form-control select_criterios" formControlName="anyo" [(ngModel)]="filtroAnyoDp" (ngModelChange)="resetearValidacion();cargarFiltros('anyo')" [ngClass]="{ 'is-invalid': submittedDp && tieneErroresDp['anyo'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let anyo of listaAnyoDp" [value]="anyo">{{anyo}}</option>
			</select>
			<div *ngIf="submittedDp && tieneErroresDp['anyo']" class="invalid-feedback position-absolute">
				<div *ngIf="tieneErroresDp['anyo']">Campo requerido</div>
			</div>
		</div>
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label>
			<label class="titulo_criterios-obligatorio ml-2">(obligatorio)</label>
			<select id="select_periodo" class="form-control select_criterios" formControlName="periodo" [(ngModel)]="filtroPeriodoDp" (ngModelChange)="resetearValidacion();cargarFiltros('periodo')" [ngClass]="{ 'is-invalid': submittedDp && tieneErroresDp['periodo'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let periodo of listaPeriodoDp" [value]="periodo.periodoAcademicoId">{{periodo.periodoDescripcion}}</option>
			</select>
			<div *ngIf="submittedDp && tieneErroresDp['periodo']" class="invalid-feedback position-absolute">
					<div *ngIf="tieneErroresDp['periodo']">Campo requerido</div>
			</div>
		</div>
		<div class="col-4">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Sede</label>
			<label class="titulo_criterios-obligatorio ml-2" *ngIf="!rolDaraCentralDp">(obligatorio)</label>
			<select id="select_periodo" class="form-control select_criterios" formControlName="sede" [(ngModel)]="filtroSedeDp" (ngModelChange)="resetearValidacion();cargarFiltros('sede')" [ngClass]="{ 'is-invalid': submittedDp && tieneErroresDp['sede'] }">
				<option [value]="0">Seleccionar</option>
				<option *ngFor="let sede of listaSedeDp" [value]="sede.sedeId">{{sede.descripcion}}</option>
			</select>
			<div *ngIf="submittedDp && tieneErroresDp['sede']" class="invalid-feedback position-absolute">
				<div *ngIf="tieneErroresDp['sede']">Campo requerido</div>
			</div>
		</div>
		
		<div class="col-2 centrar_iconos_botones">
			<button class="boton-buscar" (click)="actualizarLista()" data-toggle="tooltip" data-placement="top" title="BUSCAR" alt="BUSCAR"><i class="bi bi-search"></i></button>
		</div>
		<div class="col-1 centrar_iconos_botones">
			<button (click)="limpiarFiltros()" class="boton-secundario tamanio_iconos-boton" data-toggle="tooltip" data-placement="top" title="LIMPIAR" alt="LIMPIAR"><i class="bi bi-x"></i></button>
		</div>
	</div>
	<div class="row mt-4 align-items-end">
		<div class="col-2">
			<label class="titulo_criterios" for="exampleFormControlSelect2">ID Docente</label>
			<div class="input-group">
				<mat-autocomplete #autoDocentes="matAutocomplete" [displayWith]="displayFnCodDocentes">
					<mat-option *ngFor="let docente of filteredCodDocentesDp | async" [value]="docente">
							{{docente?.codigo}}
					</mat-option>
				</mat-autocomplete>
				<input type="text" (keypress)="keypressNumber($event)" id="inputCodDocente" [formControl]="searchCodDocenteFormDp" formControlName="idDocente" [matAutocomplete]="autoDocentes" class="form-control select_criterios" placeholder="" (ngModelChange)="resetearValidacion('inputSearchCodDocente')" [ngClass]="{ 'is-invalid': submittedDp && tieneErroresDp['idDocente'] }">
				<div *ngIf="submittedDp && tieneErroresDp['idDocente']" class="invalid-feedback">
					<div *ngIf="tieneErroresDp['idDocente']" class="position-absolute">Campo requerido</div>
				</div>
			</div>
		</div>
		<div class="col-4">
			<label class="titulo_criterios" for="exampleFormControlSelect2">Nombre Docente</label>
			<div class="input-group">
				<mat-autocomplete #autoNombreDocentes="matAutocomplete" [displayWith]="displayFnNombreDocentes">
					<mat-option *ngFor="let docente of filteredNombreDocentesDp | async" [value]="docente">
							{{docente?.primerNombre}} {{docente?.apellidoPat}} {{docente?.apellidoMat}}
					</mat-option>
				</mat-autocomplete>
				<input type="text" id="inputNombreDocente" [formControl]="searchNombreDocenteFormDp" formControlName="nombreDocente" [matAutocomplete]="autoNombreDocentes" class="form-control select_criterios" placeholder="" (ngModelChange)="resetearValidacion('inputSearchNombreDocente')">
			</div>
		</div>
	</div>
</form>
<!-- FIN CRITERIO DE BUSQUEDA -->
	
<div class="row justify-content-end mt-5">
	<button (click)="navToCrearReemplazoDocente()" class="boton-primario mr-4 mt-2" style="position: absolute;"><i class="bi bi-plus-lg mr-2"></i>CREAR REEMPLAZO DOCENTE</button>
</div>
	
	
<!-- TABLA -->
<div style="margin-top: 60px;">
	<table *ngIf="renderTableDp" datatable [dtOptions]="dtOptionsDp" class="table row-border hover table-striped display nowrap" aria-describedby="tabla reemplazo docente">
		<thead class="header_tabla">
		<tr>
			<th>Sede</th>
			<th>Sección</th>
			<th>ID Docente</th>
			<th>Nombre docente</th>
			<th>ID Reemplazo</th>
			<th>Nombre Reemplazo</th>
			<th>Fecha inicio</th>
			<th>Fecha término</th>
			<th>Acción</th>
		</tr>
		</thead>
		<tbody>
			<tr *ngFor="let reemplazo of listaReemplazosDp; index as indexReemplazo">
				<td><p class="celda">{{ reemplazo.sede }}</p></td>
				<td><p class="celda">{{ reemplazo.seccion }}</p></td>
				<td><p class="celda">{{ reemplazo.codigoDocente }}</p></td>
				<td><p class="celda">{{ reemplazo.nombreDocente }}</p></td>
				<td><p class="celda">{{ reemplazo.codigoDocenteReemplazo }}</p></td>
				<td><p class="celda">{{ reemplazo.nombreDocenteReemplazo }}</p></td>
				<td><p class="celda">{{ reemplazo.fechaInicio }}</p></td>
				<td><p class="celda">{{ reemplazo.fechaTermino }}</p></td>
				<td class="d-flex justify-content-center py-0">
					<app-popover [popoverId]="indexReemplazo">
						<ul>
							<li class="list-group-item border-0 py-1 popover-item-disabled" *ngIf=" reemplazo.vigente === 0 || !fechaValidaEliminar(reemplazo)" title="Editar" >
								<div class="row align-items-center">
									<div class="col-2 text-center p-0">
										<i class="bi bi-pencil-square boton-accion_popover px-3"></i>
									</div>
									<div class="col-10 p-0 text-left">
										<p class="mb-0 pl-4">Editar</p>
									</div>
								</div>
							</li>
							<li class="list-group-item border-0 py-1" *ngIf=" reemplazo.vigente === 1 && fechaValidaEliminar(reemplazo)" title="Editar" (click)="navToEditarReemplazoDocente(reemplazo)" >
								<div class="row align-items-center">
									<div class="col-2 text-center p-0">
										<i class="bi bi-pencil-square boton-accion_popover px-3"></i>
									</div>
									<div class="col-10 p-0 text-left">
										<p class="mb-0 pl-4">Editar</p>
									</div>
								</div>
							</li>
							<li class="list-group-item border-0 py-1 popover-item-disabled" *ngIf=" reemplazo.vigente === 0 || !fechaValidaEliminar(reemplazo)" title="Eliminar" disabled>

								<div class="row align-items-center">
									<div class="col-2 text-center p-0">
										<i class="bi bi-trash boton-accion_popover px-3"></i>
									</div>
									<div class="col-10 p-0 text-left">
										<p class="mb-0 pl-4">Eliminar</p>
									</div>
								</div>
							</li>
							<li class="list-group-item border-0 py-1" (click)="eliminarReemplazo(reemplazo)" *ngIf=" reemplazo.vigente === 1 && fechaValidaEliminar(reemplazo)" title="Eliminar" disabled>

								<div class="row align-items-center">
									<div class="col-2 text-center p-0">
										<i class="bi bi-trash boton-accion_popover px-3"></i>
									</div>
									<div class="col-10 p-0 text-left">
										<p class="mb-0 pl-4">Eliminar</p>
									</div>
								</div>
							</li>
						</ul>
					</app-popover>
				</td>
			</tr>
		</tbody>
	</table>
</div>
<!-- FIN TABLA -->
<!-- MODAL ELIMINAR -->
<button id="modalEliminarBtn" type="button" class="btn btn-primary d-none" data-toggle="modal"
	data-target="#modalEliminar">Eliminar</button>
<div class="modal fade" id="modalEliminar" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class="modal-header align-items-center">
				<h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Eliminar</h1>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
					<div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
				</button>
			</div>
			<div class="modal-body">
				<form>
					<div class="row align-items-center my-3 mx-4">
						<p *ngIf="dataEliminar?.seccion && dataEliminar?.seccion !== ''" class="mb-0 ml-3">
							¿Estás seguro/a que deseas eliminar la configuración de la sección <strong>{{ dataEliminar.seccion
								}}</strong>?
						</p>
					</div>
				</form>
			</div>
			<div class="modal-footer justify-content-center">
				<div class="my-4">
					<button (click)="confirmarEliminar()" data-dismiss="modal"
						class="boton-secundario boton_secundario_modal ml-3" data-toggle="tooltip" data-placement="top">SI</button>
					<button class="boton-primario ml-3" data-toggle="tooltip" data-placement="top" title="NO" alt="NO"
						data-dismiss="modal">NO</button>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- FIN MODAL ELIMINAR -->